import React, {useEffect, useState} from "react";
import axios from "axios";
import '../../../CSS/Empleados.css'
import {URI} from '../../../Conexiones/Conexion';
import Select from "react-select";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { SlLogout,SlLogin } from "react-icons/sl";
import { getToken } from "../../../Conexiones/Conexion";

const ModalAgregar = () => {
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario
    const navigate = useNavigate()
    const obraId = parseInt(sessionStorage.getItem("obra"))
    const resIdCat =  parseInt(sessionStorage.getItem("idCH"))
    const resNomCat =  sessionStorage.getItem("nomCH")
    const [categorias, setCategorias] = useState([])
    const [herramientas, setHerramientas] = useState([])
    const [lista, setLista] = useState([])
    const [obra,setObra] = useState('')
    const [catId, setCatId] = useState(resIdCat)
    const [catNom, setCatNom] = useState(resNomCat)
    const [empleados, setEmpleados] = useState([]);
    const [idEmp,setIdEmp] = useState()
    const [pinEmpleado, setPinEmpleado] = useState()
    useEffect( ()=>{
        const getEmpleados = async () =>{
            const res = await axios.get(URI+'empleados/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setEmpleados(res.data)
        }
        getEmpleados()
    }, [])
    const handlePin = (event) =>{
        var x = document.getElementById("divpin");
        x.style.display = "block";
        setIdEmp(event.value)
    }
    
    useEffect(() => {
        const getObras = async () => {
            const res = await axios.get(URI+'obras/'+obraId,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setObra(res.data.nombreObra);
        };
        getObras();
    }, );
    useEffect( ()=>{
        const getAllCategorias = async () =>{
            const res = await axios.get(URI+'cather/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setCategorias(res.data)
        }
        getAllCategorias()
    }, [])
    useEffect( ()=>{
        const getHerramientas = async () =>{
            const res = await axios.get(URI+'herramientas/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setHerramientas(res.data)
        }
        getHerramientas()
    }, [])
   
    const handleHer = ( herId, herNom) =>{
        sessionStorage.setItem("idCH",herId)
        sessionStorage.setItem("nomCH",herNom)
        const resId =  parseInt(sessionStorage.getItem("idCH"))
        const resNom =  sessionStorage.getItem("nomCH")
        setCatId(resId)
        setCatNom(resNom)
    }

    const addTool = async (idH, codH, nomH, marH, idcH, staH) =>{
        const newTools = herramientas.filter((item) => item.idHerramienta !== idH) ;
        setHerramientas(newTools)
        const newTool = {idL: idH, codL: codH, nomL: nomH,
        marL: marH, idcL: idcH, staL: staH
        }
        setLista([...lista, newTool]) 
    }

    const deletTool = async(id, cod, nom, mar, cat, sta) => {
        const newTools = lista.filter((item) => item.idL !== id) ;
        setLista(newTools)
        const newTool = {idHerramienta: id, codigoHer: cod, nombreHer: nom,
        nombreMarca: mar, idCategoria: cat, statusHer: sta
        }
        setHerramientas([...herramientas, newTool])
    }

    const cancelar = async () => {
        if(lista.length === 0 ){
            setCatId(null)
            setCatNom(null)
            window.location.reload()
        }else{
            Swal.fire({
                title: '¿SEGURO QUE QUIERES SALIR?',
                text: "UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                showCancelButton: true,
                confirmButtonColor: '#1e2c4f',
                cancelButtonColor: '#d33',
                confirmButtonText: 'SALIR',
                cancelButtonText: 'CANCELAR'
            }).then((result) => {
                if (result.isConfirmed) {
                    setCatId(null)
                    setCatNom(null)
                    window.location.reload()
                }
            })   
        } 
    }
     
    const confirmarCredenciales = async (e) =>{
        e.preventDefault()
        var listaHerramientas = JSON.stringify(lista);
        await axios.post(URI+'salidaherramientas/',{lista:listaHerramientas,idObra:obraId, idEntrega:idUsuario, idRecibe:idEmp, pinEmp: pinEmpleado},{
            headers: {
                'Content-Type': 'application/json',
            },
            }).then(
            res => {
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                        )
                }else{
                    if(res.data.message==="¡Herramientas agregadas!"){
                        Swal.fire({
                            icon: 'success',
                            title: '¡HERRAMIENTAS AGREGADAS CORRECTAMENTE!',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/Herramientas/Salida-Herramientas')
                                window.location.reload();
                            } 
                        })
                    }else{
                        Swal.fire({
                            title: '¡ERROR!',
                            text:res.data.message,                 
                            icon: 'error',
                            confirmButtonColor: 'red',
                            allowOutsideClick: false,
                            confirmButtonText: 'ACEPTAR'
                        })
                        const pin = document.getElementById('pin');
                        pin.value = null;
                    }
                }
            }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )
    }

    return (
        <div>            
            <div className="modal fade" id="modal-agregar" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title " id="exampleModalLabel">AGREGAR HERRAMIENTAS</h5>
                            <button type="button" className="btn-close bg-white"  aria-label="Close" onClick={cancelar} ></button>
                        </div>
                        <div className="modal-body" >
                            <div className="mb-3">
                                <h5 className="modal-title text-uppercase" id="exampleModalLabel">{obra}</h5>
                            </div>
                            <div style={{width:'100%'}}>
                                <div className="lista">
                                    <div><h5>SELECCIONA UNA CATEGORIA</h5></div>
                                    <div className="dropdown" style={{textAlign:'left'}}>
                                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            CATEGORIAS
                                        </button>
                                        <ul className="dropdown-menu">
                                            {categorias.map(categoria =>{
                                                return(
                                                    <li key={categoria.idCatHer} >
                                                        <button className="dropdown-item text-uppercase" onClick={()=> handleHer(categoria.idCatHer,categoria.nombreCatHer)} >
                                                            {categoria.nombreCatHer}
                                                        </button>
                                                    </li>
                                                )
                                            })}                                   
                                        </ul>
                                    </div><span><strong><label className="text-uppercase">{catNom}</label></strong></span>
                                    <div className="table-responsive" style={{textAlign:'left', marginTop:'20px'}}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>CODIGO</th>
                                                    <th>HERRAMIENTA</th>
                                                    <th><SlLogin/></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {herramientas.map(h =>{
                                                    return(
                                                        h.idCategoria === catId && h.statusHer === "disponible"? (
                                                            <tr key={h.idHerramienta}>
                                                                <td className="text-uppercase">{h.codigoHer}</td>
                                                                <td className="text-uppercase">{h.nombreHer}</td>
                                                                <td>
                                                                    <button className='btn btncolor' 
                                                                    onClick={()=>addTool(
                                                                        h.idHerramienta, h.codigoHer, h.nombreHer, 
                                                                        h.idMarcaHer, h.idCategoria, h.statusHer
                                                                        )}>
                                                                        +
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ):(null)
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="lista">
                                    <div><h5>AGREGADAS</h5></div>
                                    <div className="table-responsive carrito" style={{backgroundColor:'#efefef', borderRadius:'20px'}} >
                                        {lista.length === 0  ?(<div><p>VACIO</p></div>):(
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >CODIGO</th>
                                                    <th >NOMBRE</th>
                                                    <th><SlLogout/></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                lista.map(item=>{
                                                    return(
                                                        <tr key={item.idL} className="text-uppercase">
                                                            <td >{item.codL}</td>
                                                            <td >{item.nomL}</td>
                                                            <td>
                                                                <span className="bi bi-trash" style={{color:'red', cursor:'pointer'}} title="ELIMINAR" 
                                                                    onClick={()=>deletTool(
                                                                        item.idL, item.codL, item.nomL, 
                                                                        item.marL, item.idcL, item.staL)} >
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center foot" >
                            <button type="button" className="btn btn-secondary"  onClick={cancelar}>CANCELAR</button>
                            {lista.length === 0 ? (
                                <button type="button" className="btn btn-light btncolor" disabled>ACEPTAR</button> 
                            ):(
                                <button type="button" className="btn btn-light btncolor"  data-bs-toggle="modal" data-bs-target="#modal-entregar">ACEPTAR</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-entregar" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title" id="exampleModalLabel">SELECIONAR EMPLEADO</h5>
                            <button type="button" className="btn-close bg-white" data-bs-toggle="modal" data-bs-target="#modal-agregar" aria-label="Close" ></button>
                        </div>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                        <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE DEL EMPLEADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <Select 
                                    classNamePrefix="select"
                                    placeholder="Selecciona una opción"
                                    name="empleado"
                                    options={empleados.map(emp =>({label:emp.nombreEmp, value:emp.idEmpleado}))}
                                    required
                                    onChange={handlePin}
                                />
                            </div>
                            <div className="mb-3" id="divpin" style={{display:'none'}}>
                                <label className="form-label">INGRESE EL PIN DEL EMPLEADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id="pin" 
                                onChange={e => setPinEmpleado(e.target.value)} required  />
                            </div>          
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modal-agregar">CANCELAR</button>                                               
                            <button type="submit" className="btn btn-light btncolor" onClick={confirmarCredenciales}>ACEPTAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAgregar;